import {constantRoutes} from '@/router'
import {getMenus} from '@/api'

const state = {
  loaded: false,
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = routes
    state.loaded = true
  }
}
const Custom = () => import('@/views/Custom')
const actions = {
  generateRoutes({commit}) {
    return new Promise(resolve => {
      getMenus().then(res => {
        let dRoute = []
        const menus = res
        let temp
        for (let i in menus) {
          let subMenu = []
          for (let j in menus[i].subMenuList) {
            subMenu.push({
              path: menus[i].subMenuList[j].url,
              id: menus[i].subMenuList[j].id,
              name: menus[i].subMenuList[j].url,
              type: menus[i].subMenuList[j].type,
              title: menus[i].subMenuList[j].name,
              content: menus[i].subMenuList[j].type === 0 ? menus[i].subMenuList[j].content : null,
              blnHasChildren: menus[i].subMenuList[j].blnHasChildren,
              thirdMenus: menus[i].subMenuList[j].children,
              meta: {
                parentPath: '/' + menus[i].url
              },
              component: Custom
            })
          }
          temp = {
            path: '/' + menus[i].url,
            name: menus[i].url,
            meta: {
              title: menus[i].name,
              banner: menus[i].headPic
            },
            children: subMenu,
            component: {
              render: c => c("router-view")
            }
          }
          dRoute.push(temp)
        }
        let result = []
        result.push(constantRoutes[0])
        result = result.concat(dRoute)
        result.push(constantRoutes[1])
        dRoute = result
        commit('SET_ROUTES', dRoute)
        resolve(dRoute)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js